/** @jsx jsx */
import { jsx } from '@emotion/react';

import Imgix from 'js/components/Imgix';

import { NAV_SQUARE_LOGO_SIZE } from 'bundles/unified-description-page-common/constants';

import _t from 'i18n!nls/xdp';

type Props = {
  imageSrc?: string;
  partnerName?: string;
};

const NavPartnerLogo = ({ imageSrc, partnerName }: Props) => {
  if (!imageSrc) {
    return null;
  }

  return (
    <Imgix
      src={imageSrc}
      alt={partnerName || _t('Partner')}
      maxWidth={NAV_SQUARE_LOGO_SIZE}
      maxHeight={NAV_SQUARE_LOGO_SIZE}
    />
  );
};

export default NavPartnerLogo;
